export default {
  filters: {
    addFilter: "Add filter",
    filterCategories: "Filter Catergories",
  },
};
